"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNow = exports.formatDate = exports.ExportDateTimeFormat = exports.ExportDateFormat = exports.ExportTimeFormat = exports.RECENTLY_CLOSED_MINS = exports.DEFAULT_WHENMISSED = exports.DEFAULT_WHENCANSTART = exports.DEFAULT_WHENCANVIEW = exports.WEEK_MINS = exports.DAY_MINS = exports.HOUR_MINS = exports.SimpleDateTimeFormat = exports.TinyDateFormat = exports.SimpleDateFormat = exports.SimpleTimeFormat = exports.DefaultTimezone = exports.NiceDateFormat = exports.DateTimeFormat = exports.SQLDateTimeFormat = exports.ISODateTimeFormat = exports.FileTimeStampFormat = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.FileTimeStampFormat = 'YYYYMMDDHHmmss';
exports.ISODateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ';
exports.SQLDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
exports.DateTimeFormat = 'ddd, MMM D YYYY @ h:mm A';
exports.NiceDateFormat = 'ddd, MMM Do YYYY';
exports.DefaultTimezone = 'Europe/London';
exports.SimpleTimeFormat = 'hh:mm A';
exports.SimpleDateFormat = 'MMM D YYYY';
exports.TinyDateFormat = 'Do MMM';
exports.SimpleDateTimeFormat = 'MMM D, HH:mm A';
exports.HOUR_MINS = 60;
exports.DAY_MINS = exports.HOUR_MINS * 24;
exports.WEEK_MINS = exports.DAY_MINS * 7;
exports.DEFAULT_WHENCANVIEW = exports.HOUR_MINS * 12;
exports.DEFAULT_WHENCANSTART = exports.HOUR_MINS;
exports.DEFAULT_WHENMISSED = exports.DAY_MINS;
exports.RECENTLY_CLOSED_MINS = 720;
exports.ExportTimeFormat = 'hh:mm A Z';
exports.ExportDateFormat = 'YYYY-MM-DD';
exports.ExportDateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ';
const formatDate = (d, timezone = exports.DefaultTimezone, format = exports.DateTimeFormat) => {
    if (!d)
        return '';
    return moment_timezone_1.default.tz(d, timezone).format(format);
};
exports.formatDate = formatDate;
const formatNow = (timezone = exports.DefaultTimezone, format = exports.DateTimeFormat) => {
    return moment_timezone_1.default.tz((0, moment_timezone_1.default)(), timezone).format(format);
};
exports.formatNow = formatNow;
